/**
 * How a route relates to the enhanced cart flyout (SUN-292).
 *
 * Set on `route.meta.cartFlyoutEnhancement` and read only through `useEnhancedFlyout`. **Absence is
 * exclusion** — this stays an allow-list, so a route added tomorrow keeps today's behaviour until
 * someone opts it in.
 *
 * The two members exist because the kill switch and the allow-list answer different questions.
 * `VITE_FEATURE_CART_FLYOUT_ENHANCEMENT` exists to put *the storefront* back the way it was: off means
 * the flyout behaves as it did before this work, legacy toasts included. That is a coherent thing to
 * ask for on a page that has a "before" — and an incoherent one on the sandbox, which has no previous
 * behaviour to fall back to and renders nothing but the new sequence. Switching the storefront off
 * used to switch the sandbox off with it, which is the switch reaching past what it was built to
 * govern.
 */
export enum CartFlyoutEnhancement {
  /** Enhanced here, as long as the storefront kill switch is on. Every customer-facing route. */
  WhenEnabled = 'when-enabled',
  /**
   * Enhanced here regardless of the kill switch. The sandbox only — it renders the new sequence and
   * nothing else, so the switch that can hold the storefront back is precisely the one that must not
   * reach it. That is true whichever way the switch currently points: the sandbox is where the
   * sequence gets evaluated when the storefront is not running it.
   */
  Always = 'always'
}
